export default class ViewHelpers
{
    public static setButtonEnabled(button: Element, enabled: boolean)
    {
        if (enabled)
        {
            button.classList.remove('loading');
            button.removeAttribute('disabled');
        }
        else
        {
            button.classList.add('loading');
            button.setAttribute('disabled', '');
        }
    }
}